import { io } from "socket.io-client";
import { getAuthCredentials } from "./auth";
import Swal from "sweetalert2";

let socket;
let alertTimerId = null;
let alertOpen = false;
const ALERT_DELAY_MS = 10000;

export const createSocket = () => {
  if (socket) return socket;

  const currentPath = window.location.pathname;
  if (currentPath !== "/views/kitchen" && currentPath !== "/views/front") {
    return null;
  }

  const url = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  console.log("[FOH] using socket url:", url, process.env);

  socket = io(url, {
    path: "/socket.io",
    transports: ["polling", "websocket"],
    timeout: 120000,
    auth: { posId: getAuthCredentials()?.posId },
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 2000,
    reconnectionDelayMax: 20000,
  });

  const scheduleAlert = (msg) => {
    if (alertTimerId || alertOpen) return;
    alertTimerId = setTimeout(() => {
      alertTimerId = null;
      if (socket.connected) return;
      alertOpen = true;
      Swal.fire({
        icon: "error",
        title: "Connection Lost",
        text: `${msg}\nPress Reload to reconnect or Ignore to stay.`,
        showCancelButton: true,
        confirmButtonText: "Reload",
        cancelButtonText: "Ignore",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        alertOpen = false;
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }, ALERT_DELAY_MS);
  };

  const clearPendingAlert = () => {
    if (alertTimerId) {
      clearTimeout(alertTimerId);
      alertTimerId = null;
    }
    if (alertOpen) {
      Swal.close();
      alertOpen = false;
    }
  };

  socket.on("connect", () => {
    clearPendingAlert();
    const { posId } = getAuthCredentials() || {};
    const room = `pos:${posId}`;
    console.log(
      `[FOH] connected via ${socket.io.engine.transport.name} id=${socket.id} posId=${posId} -> joining ${room}`
    );
    socket.emit("join-pos-room", { room, posId });
  });

  socket.io.on("upgrade", (transport) => {
    console.log("[FOH] upgraded transport:", transport.name);
  });

  socket.on("connect_error", (err) => {
    console.error("[FOH] connect_error", err.message);
    if (!socket.connected) scheduleAlert("You were disconnected.");
  });

  socket.on("reconnect_attempt", (n) => {
    console.log("[FOH] reconnect_attempt", n);
  });

  socket.on("reconnect", (n) => {
    console.log("[FOH] reconnect", n);
    clearPendingAlert();
  });

  socket.on("reconnect_error", (err) => {
    console.warn("[FOH] reconnect_error", err.message);
  });

  socket.on("reconnect_failed", () => {
    console.error("[FOH] reconnect_failed: giving up");
    clearPendingAlert();
    Swal.fire({
      icon: "error",
      title: "Connection Lost",
      text: "Unable to reconnect to the server.\nPress the button to reload and reconnect.",
      confirmButtonText: "Reload",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => window.location.reload());
  });

  socket.on("disconnect", (reason) => {
    console.warn("[FOH] disconnected:", reason);
    if (reason !== "io client disconnect") {
      scheduleAlert("You were disconnected.");
    }
  });

  return socket;
};
